export const environment = {
  production: true,
  API_URL: "https://decisiel-admin-prod.azurewebsites.net/",
  API_SERVICE_URL: "//api.decisiel-expertise.fr/api/v1.0/",  
  RECAPTCHA_SITE_KEY: "6LdYSIMhAAAAAOa6lQz3Ls2O_hBoDwGmR1riyJT0", 
  API_SIMULATEUR_KEY: "RklQQVJDT19CQ09fU0lNVUxBVEVfUE9SVEFHRQ=="
};
